<template>
  <div class="hero-section">
    <div class="wrap">
      <div class="hero-content">
        <h1 class="hero-title">
          <span class="hero-title-line">山东省二级注册建造师</span>
          <span class="hero-title-line">继续教育平台</span>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "hero-section",
};
</script>

<style scoped lang="scss">
.hero-section {
  position: relative;
  width: 100%;
  min-height: 260px;
  /* 背景图：济南泉城广场（轻量蓝色渐变叠加，整体更明亮） */
  background:
    linear-gradient(180deg, rgba(9, 38, 74, 0.14) 0%, rgba(9, 38, 74, 0.26) 100%),
    url("@/assets/imgs/quancheng_square.jpg") center 50% / cover no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  isolation: isolate;
}

// ============ 居中标题 ============
.hero-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  z-index: 2;
}

.hero-title {
  margin: 0;
  text-align: center;
  font-size: 46px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 8px;
  line-height: 1.3;
  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.55);

  .hero-title-line {
    display: block;
    text-indent: 8px; // 抵消末字字距，保证视觉居中
  }
}

// ============ 响应式 ============
@media (max-width: 992px) {
  .hero-title { font-size: 34px; letter-spacing: 5px; }
  .hero-title .hero-title-line { text-indent: 5px; }
}

@media (max-width: 600px) {
  .hero-section { min-height: 140px; }
  .hero-title { font-size: 22px; letter-spacing: 3px; }
  .hero-title .hero-title-line { text-indent: 3px; }
}
</style>
